import React from 'react';
import { Link } from 'react-router-dom';
import LogoSignSvg from 'images/v5/logo-sign.svg';
import styles from './LogoSign.module.scss';
function LogoSign() {
    return (React.createElement(Link, { to: "/", className: styles.wrap },
        React.createElement(LogoSignSvg, { width: "85", height: "14" })));
}
export default LogoSign;
